import { cn } from '#app/utils/misc.tsx'

export function Title({
	children,
	component = 'h1',
	className,
	...props
}: React.HTMLAttributes<HTMLHeadingElement> & { component?: React.ElementType }) {
	let RComponent = component
	return (
		<RComponent
			{...props}
			className={cn('text-balance font-light leading-[1.1] tracking-[-0.08em] text-neutral-950', className)}
		>
			{children}
		</RComponent>
	)
}
